import React, { Component, Fragment } from 'react'
import { STEP_TYPES } from '../constants'
import { pathOr } from 'ramda'
import PropTypes from 'prop-types'
import DemoRequestStep from '../component'
import BotPreview from 'components/OnboardingBotPreview'


const STEP_OBJECT = Object.freeze(STEP_TYPES.PRODUCT_NAME)
class ProductStep extends Component {

  static propTypes = {
    index: PropTypes.number.isRequired,
    stepCount: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    const prefilledProductName = !!props.productName ? props.productName : (props.companyName || '')
    this.state = {
      productName: prefilledProductName,
      previewInputValue: prefilledProductName === '' ? STEP_OBJECT.previewTextDefault : prefilledProductName,
    }
  }

  handleInputChange = (event) => {
    const { previewTextDefault } = STEP_OBJECT
    const changedValue = pathOr('', ['target', 'value'], event)
    const previewChangedValue = !!changedValue ? changedValue : previewTextDefault
    this.setState({ productName: changedValue, previewInputValue: previewChangedValue })
  }

  handleProductNameSave = () => {
    const { actions } = this.props
    const { productName } = this.state
    actions.setProductName(productName)
  }

  render() {
    const { productName, previewInputValue } = this.state
    const valuePropPreview = STEP_TYPES.VALUE_PROP.previewTextDefault
    const botPreview = <BotPreview productName={previewInputValue} valueProp={valuePropPreview} tipText={STEP_OBJECT.tipText} arrowSource={STEP_OBJECT.arrowSource} />
    return (
      <Fragment>
        <DemoRequestStep stepObject={STEP_OBJECT} botPreview={botPreview} inputValue={productName} handleSave={this.handleProductNameSave} handleInputChange={this.handleInputChange} {...this.props} />
      </Fragment>
    )
  }
}

export default ProductStep



// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookDemoRequestStep/ProductStep/index.js